import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';

// Log important REACT_APP_ vars as early as possible for troubleshooting
const _clientId = process.env.REACT_APP_CLIENT_ID || '<undefined>'; 
const _serverUrl = process.env.REACT_APP_SERVER_URL || '<undefined>'; 
/* eslint-disable no-console */
console.log('REACT_APP_CLIENT_ID=', _clientId);
console.log('REACT_APP_SERVER_URL=', _serverUrl);
/* eslint-enable no-console */
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
